'use strict';
module.exports = require('./TabPanel.vue');